import GlobalModalType from '../types/GlobalModalType';

export const showModal = (options, modalComponent) => {
  return {
    payload: { options, modalComponent },
    type: GlobalModalType.actions.showModal,
  };
};

export const hideModal = () => {
  return {
    payload: {},
    type: GlobalModalType.actions.hideModal,
  };
};
